module.exports = __webpack_public_path__ + "img/strat.12985b9a.svg";